import React, { Component } from 'react';

import './styles.less';

class EmbedCodeDropdownItem extends Component {
  render() {
    return (
      <li
        className="share-video-embed-code-dropdown-item"
        onClick={this.props.onClick}
      >
        <div className="icon" />
        <span>Embed</span>
      </li>
    );
  }
}

export default EmbedCodeDropdownItem;
